import "./PreAccessDocumentsTab.css";

import { FileBlueIcon } from "../../../../../../../assets";
import { usePreAccessDocumentsTab } from "./usePreAccessDocumentsTab";

interface PreAccessDocumentsTabProps {
  /** The asset manager portal rounds its cards; the developer and development manager portals do not. */
  isRounded?: boolean;
}

/** The project's public documents, for a user who cannot read the project. */
export const PreAccessDocumentsTab = ({ isRounded = false }: PreAccessDocumentsTabProps): JSX.Element => {
  const { documents, isLoading, hasError, downloadDocument } = usePreAccessDocumentsTab();

  return (
    <div className={`PreAccessDocumentsTab${isRounded ? " PreAccessDocumentsTab_rounded" : ""}`}>
      <h2>Documents</h2>
      {!isLoading && hasError && (
        <p className="PreAccessDocumentsTab_emptyState body2">This project&apos;s documents couldn&apos;t be loaded.</p>
      )}
      {!isLoading && !hasError && (
        <div className="PreAccessDocumentsTab_list">
          {documents && documents.length ? (
            documents.map((documentItem) => (
              <button
                className="PreAccessDocumentsTab_item"
                key={documentItem.uuid}
                onClick={() => downloadDocument(documentItem.versionUuid)}
                type="button"
              >
                <div className="PreAccessDocumentsTab_itemInfo">
                  <FileBlueIcon />
                  <div className="PreAccessDocumentsTab_textGroup">
                    <p className="PreAccessDocumentsTab_title body1">{documentItem.type}</p>
                    {documentItem.customVariant || documentItem.variant ? (
                      <p className="PreAccessDocumentsTab_variant body1">
                        {documentItem.customVariant || documentItem.variant}
                      </p>
                    ) : null}
                  </div>
                </div>
                <p className="PreAccessDocumentsTab_uploadedDate body2">
                  {`Uploaded on ${documentItem.createdAt.toLocaleDateString("en-GB")}`}
                </p>
              </button>
            ))
          ) : (
            <p className="PreAccessDocumentsTab_emptyState body2">This project doesn&apos;t have any documents yet.</p>
          )}
        </div>
      )}
    </div>
  );
};
